var MouseDragTracker = require('./shape/helper/mouseTracker');

module.exports = {
    /**
     * Note: these called from the originals
     * Returns true if want to continue, else false
     * Sets: this.mouseModel, this.bbox, model.mouseDrawing(true), the event handlers
     * can think of as mousedown
     */
    start: function(e) {

        var ch = this.channel;

        // Only allow if drawing is enabled and not already drawing ( this.model.get('isDrawing') ) -- get rid for poly-redact
        // TODO: can't have b/f other clicks to catch -- put catch of mousedown prior to draw start for clarity
        if (!ch.request('editMode')) 
            return false;

        e.preventDefault(); //IE
        e.stopPropagation();

        // Disallow right: be able to capture on shapes ... (unselect any shapes)
        if (e.which !== 1) 
            return false;

        // allow to draw on other shape, but not if button
        // div is for DVBC-893 shim (with IE8)
        // tspan is for redaction reason codes
        var targetNode = $(e.target)[0].nodeName.toUpperCase(),
            targetIsRaphaelElement = targetNode !== 'SVG' && targetNode !== 'IMG' && 
                targetNode !== 'TEXTAREA' && targetNode !== 'TSPAN' && targetNode !== 'DIV';

        if (targetIsRaphaelElement) {

            var rId = e.target.raphaelid,
                rEl = this.paper.getById(rId),
                rElShapeType = rEl.data('shapeType'),
                isExitEl = rElShapeType === 'button'; //|| rElShapeType === 'selectHandle' (want to prop to handle)

            if (isExitEl) {
                return false;
            }


        }

        /* _____________ the drawing ______________ */

        //TODO: facade combining both
        ch.command('setSelectedShape', null);  // do after the above which looks for other clicks (eg that from the delete button; if before will break
        ch.command('toggleUserDrawing', true); // use in case -- esp for drawing poly -- don't allow new mousedown events

        // Start the Mousedown Tracker
        this.mouseModel = new MouseDragTracker({
            xy: this.getMousePos(e)
        });

        return true;
    },
    move: function (e, x, y) {

        e.preventDefault();
        e.stopPropagation();

        var mm = this.mouseModel.update( this.getMousePos(e) );
        if ( mm.noChangeInOriginalPosition() )
            return false;

        // TODO: this may not be working  ... at least for line ... may want to use container relational here
        // forget the original purpose
        if ( !this.mouseInBounds(x, y) ) {

            this.$el
                .off('mouseup', this.drawStop)
                .off('mousedown', this.drawStart)
                .on('mousedown', this.drawStop);

            return false;
        }

        return true;
    },
    end: function (e) {

        e.preventDefault();
        e.stopPropagation();

        //TODO: combo both calls even though R fn ... b/c trickle down

        this.shape.removeCachedBox();
        /* necessary for IE8 fix involved with newer Raphael version and getBoxTransformStr (and also provides a perf boost) */
        //TODO: would like to call off the shape view, but not yet created ... fired off something else ..
            // note: not the 'selectedShape' of the canvas yet

        this.mouseModel.update(this.getMousePos(e));
        this.channel.command('toggleUserDrawing', false);  //don't unselect all shapes (already done at start)

    },

    /*
    * Set attributes of to-be-shape's Raphael element prior to its view being created.
    * (Can't call on shape view yet; it's created on the end of the draw (when added to the shapes collection).
    * */
    setShapeAttrs: function( rEl ) {

        var ch = this.channel;

        rEl.attr(
            ch.request( 'getAttributesToApplyToShapeEl',
                ch.request('activeNote'),
                true,
                null,
                ch.request('activeNoteSubType') )
        );

    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/baseCanvasDrawFns.js
 ** module id = 360
 ** module chunks = 0
 **/